<template>
  <div id="app" ref="app" :class="[{'scrolled-25': scrolled25, 'scrolled-75': scrolled75}]">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    scrolled25: false,
    scrolled75: false
  }),
  mounted() {
    let that = this
    this.axios.interceptors.response.use(function (response) {
      // Do something with response data
      return response
    }, function (error) {
      // Do something with response error
      if (error.response.status === 401) {
        if (that.$store.state.tokens) {
          that.$store.commit("CLEAR_USER_DATA")
        }
      }
      return Promise.reject(error)
    })

    this.axios.get('/api/config').then((response) => {
      for (let authority of response.data.authorities) {
        this.$store.commit('ADD_AUTHORITY', authority) 
      }
      for (let classification of response.data.classifications) {
        this.$store.commit('ADD_CLASSIFICATION', classification) 
      }
      for (let type of response.data.types) {
        this.$store.commit('ADD_TYPE', type) 
      }
    })

    document.addEventListener('scroll', () => {
      setScrolled()
    })
    
    function setScrolled() {
      
      if (window.scrollY > 25) {
        that.scrolled25 = true
      } else {
        that.scrolled25 = false
      }

      if (window.scrollY > 75) {
        that.scrolled75 = true
      } else {
        that.scrolled75 = false
      }
    }
    setScrolled()

    let tries = 0
    function tabindex() {
      if (tries < 3) {
        tries++
        setTimeout(() => {
          let cookieButton = document.getElementById('Coi-Renew')
          if (cookieButton) cookieButton.setAttribute('tabindex', '-1')
          else {
            tabindex()
          }
        }, 250)
      }
    }
    tabindex()
  },
}
</script>

<style lang="scss">
$primary: #003187;
$secondary: #c8102e;
$info: rgba(229, 249, 247, .9);
$light: #f1f0ef;
$gray: #0c0a0a;
$danger: rgba(200, 16, 46, .5); // #c8102e
$success: rgba(23, 135, 0, 1); // #178700
$warning: rgba(168, 155, 7, .5); // #a89b07
$green: #2ec810;
@import 'node_modules/bootstrap/scss/bootstrap';
@import 'node_modules/bootstrap-vue/src/index.scss';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  & .medium {
    font-size: 100%;
  }
  & .large {
    font-size: 120%;
    h1, .h1 { font-size: 2.5rem; }
    h2, .h2 { font-size: 2.25rem; }
    h3, .h3 { font-size: 2rem; }
    h4, .h4 { font-size: 1.75rem; }
    h5, .h5 { font-size: 1.5rem; }
    h6, .h6 { font-size: 1.25rem; }
  }
  & .x-large {
    font-size: 140%;
    h1, .h1 { font-size: 2.75rem; }
    h2, .h2 { font-size: 2.5rem; }
    h3, .h3 { font-size: 2.25rem; }
    h4, .h4 { font-size: 2rem; }
    h5, .h5 { font-size: 1.75rem; }
    h6, .h6 { font-size: 1.5rem; }
  }
}

.ignore-font-size, .ignore-font-size * {
  font-size: initial !important;
}

a:link:not(.btn) {
  text-decoration: underline;
}

#main-nav {
  transition: all 0.15s ease-out;
  a {
    color: #333;
    text-decoration: none;
  }
}

.main-nav-wrap {
  border-top: 10px solid $secondary;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 1001;
  background-color: white;
  transition: all 0.15s ease-out;
}

.scrolled-25 {
  .main-nav-wrap {
    box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.25)
  }
}

.content-wrap {
  margin-top: 110px;
}

h1, h2, h3, h4, h5, h6 {
  color: $primary;
}

.hidden-text{
  position:absolute;
  left:-10000px;
  top:auto;
  width:1px;
  height:1px;
  overflow:hidden;
}

img {
  max-width: 100%;
  height: auto;
}

.pointer:hover {
  cursor: pointer;
}

.loading-area {
  min-height: calc(100vh - 120px);
  position: relative;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 3px;

  span {
    position: absolute;
    top: 50%;
    margin-top: -16px;
  }
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

@media (min-width: 768px) {
  .order-md-1 {
    order: 1;
  }

  .order-md-2 {
    order: 2;
  }
}

/* .scrolled-75 .scroll-fixed {
  position: fixed;
  margin-top: -75px;
} */

.btn-xs, .btn-group-xs > .btn {
  padding: 0.1rem 0.25rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.sidebar {
  float: left;
  height: calc(100vh - 110px);
  background-color: #f6f6f6;
  position: fixed;
  z-index: 1000;
  transition: all .25s ease-in-out;
  overflow: hidden;
  
  &.shown {
    width: 300px;
  }
  &.hidden {
    width: 55px;
    .sidebar-content {
      opacity: 0;
    }
    &:hover {
      width: 300px;
      .sidebar-content {
        opacity: 1;
      }
    }
  }
  .sidebar-content {
    height: calc(100vh - 170px);
    overflow-x: hidden;
    overflow-y: auto;
    opacity: 1;
    width: 300px;
    transition: opacity .25s ease-in-out;
  }
}

.content {
  margin-left: 55px;
  transition: margin-left .05s ease-in-out;
  &.sidebar-shown {
    margin-left: 300px;
  }
}

.select-buttons .btn,
.check-buttons .btn,
.check-list .list-group-item {
  background-color: #e9e9e9 !important;
  border-color: #e9e9e9 !important;
  color: #666666 !important;
}

.check-list .list-group-item {
  height: auto;
  min-height: 42px;
}

.select-buttons .btn:hover,
.check-buttons .btn:hover,
.check-list .list-group-item:hover {
  background-color: darken(#e9e9e9, 5%) !important;
  border-color: darken(#e9e9e9, 5%) !important;
  color: darken(#666666, 5%) !important;
}

.check-list .list-group-item:hover {
  cursor: pointer;
}

.check-buttons .btn {
  text-align: left;
  padding-right: 50px;
}

.check-buttons .btn + .btn,
.check-list .list-group-item + .list-group-item {
  border-top: 1px solid rgba(0,0,0,.05) !important;
}

.check-buttons .btn + .btn.active,
.check-list .list-group-item + .list-group-item.active {
  border-top: 1px solid rgba(255,255,255,.25) !important;
}

.check-buttons .btn.active,
.select-buttons .btn.active,
.check-list .list-group-item.active {
  background-color: $primary !important;
  border-color: $primary !important;
  color: white !important;
}

.check-buttons .btn.active:after,
.check-list .list-group-item.active:after {
  content: "";
  background-image: url('/img/check.svg');
  background-size: 110%;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  right: 10px;
  top: 10px;
  width: 20px;
  bottom: 10px;
}

.font-size-buttons .btn {
  height: 25px;
  line-height: 25px;
  padding: 0;
  width: 30px;
}

.font-size-buttons .btn + .btn {
  border-left: 1px solid rgba(0,0,0,.05) !important;
}

// Transitions
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fold-enter-active, .fold-leave-active {
  transition: all .25s;
  overflow: hidden;
}

.fold-enter, .fold-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0 !important;
  min-height: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}

.opacity-quarter {
  opacity: .25;
}

.table-sm th, .table-sm td {
  font-size: 1rem;
}

.card.plain {
  border: none;
  border-radius: 0;
}

.small-label {
  position: absolute;
  top: -3px;
  left: 20px;
  z-index: 10;
  font-size: 0.65em;
  line-height: 0.65em;
  background-color: white;
  margin: 0;
  padding: 0 5px;
}
.print-details {
  display: none;
}
@media print {
  @page { size: portrait; }
  *, p, h1, h2, h3, h4, h5, h6, .text-primary {
    color: #000 !important;
  }
  #app .medium,
  #app .large,
  #app .x-large {
    font-size: 100% !important; 
  }
  body {
    margin: 20mm 10mm 0 10mm;
    width: 190mm;
    min-width: auto !important;
  }
  .print-details {
    display: block;
  }
  .hide-on-print,
  .newsletter-sign-up,
  .main-nav-wrap,
  .sidebar,
  footer {
    display: none !important;
  }
  .content-wrap {
    margin-top: 0;
  }
  .content {
    margin-left: 0 !important;
    width: 100% !important;
  }
}
</style>
